import React from 'react';
import PropTypes from 'prop-types';
import {Box, Text, Heading} from '@spothero/ui';
import ReservationUtils from 'utils/reservation-utils';
import {PROPTYPE_RESERVATION_EVENT} from '@/proptypes/reservation-prop-types';

const Header = ({redemptionType, title, displayId, event, partnerName}) => {
    const isDisplayIdRedemption =
        redemptionType ===
        ReservationUtils.PARKING_PASS_REDEMPTION_TYPE.DISPLAY_ID;

    return (
        <Box
            sx={{
                '@media print': {
                    color: 'black',
                },
            }}
            color="white"
        >
            <Heading as="h1" marginY={2}>
                Parking Pass
            </Heading>
            {event ? (
                <Text
                    fontSize={{base: 'base', tablet: 'lg'}}
                    fontWeight="semibold"
                    marginBottom={{base: 2, tablet: 3}}
                >
                    {event.title}
                </Text>
            ) : null}
            <Text
                fontSize={
                    event
                        ? {base: 'sm', tablet: 'base'}
                        : {base: 'base', tablet: 'lg'}
                }
                fontWeight={
                    event ? {base: 'normal', tablet: 'semibold'} : 'semibold'
                }
                data-testid="Header-text-facilityname"
            >
                {title}
            </Text>
            {!isDisplayIdRedemption || partnerName ? (
                <Text
                    display="flex"
                    fontSize={{base: 'sm', tablet: 'base'}}
                    marginTop={1.5}
                    lineHeight={'1'}
                    marginBottom={1}
                >
                    {!isDisplayIdRedemption && (
                        <Box
                            as="span"
                            display="inline-block"
                            marginRight={partnerName ? 1 : 0}
                            paddingRight={partnerName ? 1 : 0}
                            borderColor="white"
                            borderRightWidth={partnerName ? '1px' : '0'}
                        >
                            Rental ID: {displayId}
                        </Box>
                    )}
                    {partnerName ? (
                        <Box as="span">Purchased through {partnerName}</Box>
                    ) : null}
                </Text>
            ) : null}
        </Box>
    );
};

/* eslint-disable camelcase */
Header.propTypes = {
    redemptionType: PropTypes.oneOf(
        Object.values(ReservationUtils.PARKING_PASS_REDEMPTION_TYPE)
    ).isRequired,
    title: PropTypes.string.isRequired,
    displayId: PropTypes.string.isRequired,
    event: PROPTYPE_RESERVATION_EVENT,
    partnerName: PropTypes.string,
};

export default Header;
